module.exports = __webpack_public_path__ + "img/HeadExtraction05.46d6bb74.png";